<template>
  <div class="container" :class="{ 'selected': selected }">
    <div class="datum date">
      <span class="label">{{ tr('Specimen Collected Date') }}</span> <span>{{ formatDate(date) || '—' }}</span>
    </div>
    <div v-if="sampleId">
      <div class="datum specimen-type">
        <span class="label">{{ tr('Specimen Type') }}</span> <span class="specimen-type-text">{{ specimenType || '—'
        }}</span>
      </div>
      <div class="datum test-type">
        <span class="label">{{ tr('Test Type') }}</span>
        <span>{{ testType || '—' }}</span>
      </div>
    </div>
    <div class="location">
      <span class="material-symbols-outlined size-24 location-icon">
        location_on
      </span>
      <span class="location-text">{{ labName || '—' }}</span>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { defineProps } from 'vue'
import { formatDate } from '@/utils/utils'

const tr = (x) => x // inject('tr')

defineProps({
  date: {
    type: String,
    default: '',
  },
  labName: {
    type: String,
    default: '',
  },
  sampleId: {
    type: String,
    default: '',
  },
  specimenType: {
    type: String,
    default: '',
  },
  testType: {
    type: String,
    default: '',
  },
  selected: Boolean,
})
</script>

<style lang="scss" scoped>
.container {
  border-radius: 10px;
  background-color: var(--White);
  overflow: auto;
  position: relative;
  text-align: left;
  margin: 0.75rem;
  padding: 0.75rem;
  font-size: 0.8rem;

  &:hover {
    cursor: pointer;
    background-color: var(--White);
    box-shadow: 5px 5px 5px var(--Grey500);
    transition: all ease-out 200ms;
  }
}

.datum {
  margin: 5%;
  display: flex;
  flex-direction: column;
}

.location {
  color: var(--Grey500);
  margin: -2% 5% 2% 5%;
  display: flex;
  flex-direction: row;
  font-size: 90%;
}

.location-icon {
  padding-bottom: 3px;
}

.location-text {
  padding-top: 3px;
}

.specimen-type-text {
  font-weight: bold;
}

.selected {
  border: 2px solid;
}
</style>
